import { Trans, useTranslation } from 'react-i18next'
import { useApp } from '../hooks/useApp'
import { TopTitle } from '../components/atoms/TopTitle'
import { callAxios } from '../hooks/useAxios'
import { Box, Button, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Appliance, ApplianceData } from '../classes/appliances/Appliance'
import { getAppliance } from '../classes/appliances'
import { ID } from '../types/models'
import { useNavigate } from 'react-router-dom'
import { ApplianceDataTable } from '../components/ApplianceDataTable'
import { useDevices } from '../hooks/useDevices'
import InstallerLevelDialog from '../components/InstallerLevelDialog'

export function AppliancesPage() {
  const app = useApp()
  const { t } = useTranslation()
  const [appliances, setAppliances] = useState<Record<ID, Appliance[]>>({})
  const navigate = useNavigate()
  const { control } = useDevices()
  const [openInstallerDialog, setOpenInstallerDialog] = useState<boolean>(false)

  async function refresh() {
    for (const location of app.locations) {
      const resp = await callAxios<ApplianceData[]>({
        url: `/appliances?location=${location.id}`,
      })
      if (resp.success) {
        const apps = resp.data.map(appliance => getAppliance(appliance, control, app))
        apps.map(a => a.connectControls(control))
        setAppliances({ ...appliances, [location.id as ID]: apps })
      }
    }
  }

  useEffect(() => {
    refresh()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onAddAppliance = () => {
    Appliance.clearConfig()
    navigate('/appliances/new')
  }

  const handleOpenMessage = () => {
    setOpenInstallerDialog(true)
  }

  const handleCloseMessage = () => {
    setOpenInstallerDialog(false)
  }

  return (
    <>
      <TopTitle title={t('Appliances')}></TopTitle>

      {
        app.locations.map((loc, i) => (
          <Box sx={{ mt: i === 0 ? 4 : 8 }} key={i}>
            {app.locations.length > 1 && <Typography variant="h4" sx={{ mb: 1 }}>{loc.name}</Typography>}
            <ApplianceDataTable link="/appliances/:id" appliances={appliances[loc.id as ID] || []}/>
          </Box>
        ))
      }

     <Box sx={{ mt: '1.3rem', textAlign: 'center' }}>
        <Button data-cy="button-Add Appliance" onClick={app.installerLevel ? onAddAppliance : handleOpenMessage}><Trans>Add Appliance</Trans></Button>
      </Box>

      {!app.installerLevel && <InstallerLevelDialog open={openInstallerDialog} closeFunc={handleCloseMessage}></InstallerLevelDialog>}
    </>
  )
}
